<template>
  <div class="goods-content">
    <!-- Loading -->
    <div class="goods-loading" v-if="isBusy">
      <TableSpiner />
    </div>
    <!-- results -->
    <template v-else>
      <div class="goods-breadcrumb">
        <b-breadcrumb class="breadcrumb">
          <b-breadcrumb-item @click="setCurrentCategories(0)" :active="currentCategories.id === 0">
            <i class="fas fa-home"></i>
          </b-breadcrumb-item>
          <b-breadcrumb-item
            class="breadcrumb-item"
            v-for="(breadcrumb, index) in breadCrumbs"
            :key="index"
            @click="setCurrentCategories(breadcrumb.id)"
            :active="currentCategories.id === breadcrumb.id"
          >{{breadcrumb.name}}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
      <!-- Powrot -->
      <template v-if="currentCategories.parent_id !== false">
        <singleCategory
          :category="{ name:'powrót', id: currentCategories.parent_id}"
          @select="setCurrentCategories"
        />
      </template>
      <!--Categories -->
      <template v-if="currentCategories.children.length > 0">
        <singleCategory
          v-for="(category) in currentCategories.children"
          :key="'c'+category.id"
          :category="category"
          @select="setCurrentCategories"
        />
      </template>
      <!-- Products -->
      <singleProduct
        v-for="(product) in currentProducts"
        :key="'m'+product.id"
        :product="product"
        @select="$emit('selectProduct', $event)"
      />
    </template>
  </div>
</template>

<script>
import { searchRecursivelyArray } from "@/utils/index.js";
import { mapActions, mapGetters } from "vuex";
import TableSpiner from "@/components/TableSpiner";
import singleCategory from "./singleCategory";
import singleProduct from "./singleProduct";

export default {
  components: { TableSpiner, singleCategory, singleProduct },
  data() {
    return {
      isBusy: true,
      currentCategories: {},
      breadCrumbs: []
    };
  },
  computed: {
    ...mapGetters("products", ["products", "categories"]),
    roots() {
      return {
        name: "",
        id: 0,
        children: this.categories,
        parent_id: false
      };
    },
    currentProducts() {
      return this.products.filter(
        ({ category_id }) => category_id === this.currentCategories.id
      );
    }
  },
  methods: {
    ...mapActions("products", ["get", "remove", "getCategories"]),
      setCurrentCategories(id) {
      //Nie przeliczaj jak klikamy na to samo
      if (this.currentCategories.id === id) {
        return;
      }
      //Return root
      if (id === 0) {
        this.currentCategories = this.roots;
      } else {
        this.currentCategories = searchRecursivelyArray(
          this.roots.children,
          "id",
          id
        );
      }
      //Search todo
      this.prepareBreadCrumbs();
      return;
    },
    prepareBreadCrumbs() {
      let breadCrumbs = [];

      let stop = 0;
      let maxloop = 100;

      let item = this.currentCategories;
      while (item.parent_id !== false) {
        if (stop === maxloop) {
          throw Error("Death loop");
        }
        breadCrumbs.push({ name: item.name, id: item.id });
        item = searchRecursivelyArray(
          this.roots.children,
          "id",
          item.parent_id
        );
        if (!item) {
          break;
        }
        stop++;
      }
      breadCrumbs.reverse();
      this.breadCrumbs = breadCrumbs;
    }
  },
  mounted() {
    this.isBusy = true;
    Promise.all([this.get(), this.getCategories()]).then(() => {
      this.isBusy = false;
      this.setCurrentCategories(0);
    });
  }
};
</script>